export enum WhatsAppChatType {
    Client = 0,
    CrmToken = 1,
}
